import { createContext } from 'react';

export type Locale = 'de' | 'en' | 'fr' | 'it';

export interface I18nContextValue {
  locale: Locale;
  setLocale: (locale: Locale) => void;
  t: (key: string, params?: Record<string, string | number>) => string;
}

// Kept in a dedicated module so its identity survives Fast Refresh
// when components in src/i18n/index.tsx are hot-reloaded.
export const I18nContext = createContext<I18nContextValue | null>(null);